// Class: starling.assets.AssetFactory

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function Std() {return require("./../../Std");}
function openfl_utils_ByteArray() {return $import(require("openfl/utils/ByteArray"));}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}

// Constructor

var AssetFactory = function() {
	this._mimeTypes = (openfl__$Vector_Vector_$Impl_$().default)._new();
	this._extensions = (openfl__$Vector_Vector_$Impl_$().default)._new();
}

// Meta

AssetFactory.__name__ = ["starling","assets","AssetFactory"];
AssetFactory.prototype = {
	canHandle: function(reference) {
		var mimeType = reference.get_mimeType();
		var extension = reference.get_extension();
		var isByteArray = (Std().default)["is"](reference.get_data(),(openfl_utils_ByteArray().default));
		var supportedMimeType;
		if(mimeType != null) {
			var this1 = this._mimeTypes;
			var x = reference.get_mimeType().toLowerCase();
			supportedMimeType = Array.prototype.indexOf.call(this1,x,0) != -1;
		} else {
			supportedMimeType = false;
		}
		var supportedExtension;
		if(extension != null) {
			var this2 = this._extensions;
			var x1 = reference.get_extension().toLowerCase();
			supportedExtension = Array.prototype.indexOf.call(this2,x1,0) != -1;
		} else {
			supportedExtension = false;
		}
		if(isByteArray) {
			if(!supportedMimeType) {
				return supportedExtension;
			} else {
				return true;
			}
		} else {
			return false;
		}
	},
	create: function(reference,helper,onComplete,onError) {
	},
	addMimeTypes: function(args) {
		var _g = 0;
		while(_g < args.length) {
			var mimeType = args[_g];
			++_g;
			mimeType = mimeType.toLowerCase();
			var this1 = this._mimeTypes;
			if(Array.prototype.indexOf.call(this1,mimeType,0) == -1) {
				(openfl__$Vector_Vector_$Impl_$().default).set(this._mimeTypes,this._mimeTypes.length,mimeType);
			}
		}
	},
	addExtensions: function(args) {
		var _g = 0;
		while(_g < args.length) {
			var extension = args[_g];
			++_g;
			extension = extension.toLowerCase();
			var this1 = this._extensions;
			if(Array.prototype.indexOf.call(this1,extension,0) == -1) {
				(openfl__$Vector_Vector_$Impl_$().default).set(this._extensions,this._extensions.length,extension);
			}
		}
	},
	getMimeTypes: function(out) {
		if(out == null) {
			out = (openfl__$Vector_Vector_$Impl_$().default)._new();
		}
		var _g1 = 0;
		var _g = this._mimeTypes.length;
		while(_g1 < _g) {
			var i = _g1++;
			(openfl__$Vector_Vector_$Impl_$().default).set(out,i,this._mimeTypes[i]);
		}
		return out;
	},
	getExtensions: function(out) {
		if(out == null) {
			out = (openfl__$Vector_Vector_$Impl_$().default)._new();
		}
		var _g1 = 0;
		var _g = this._extensions.length;
		while(_g1 < _g) {
			var i = _g1++;
			(openfl__$Vector_Vector_$Impl_$().default).set(out,i,this._extensions[i]);
		}
		return out;
	},
	get_priority: function() {
		return this._priority;
	},
	set_priority: function(value) {
		return this._priority = value;
	}
};
AssetFactory.prototype.__class__ = AssetFactory.prototype.constructor = $hxClasses["starling.assets.AssetFactory"] = AssetFactory;

// Init

Object.defineProperties(AssetFactory.prototype,{ "priority" : { get : function () { return this.get_priority (); }, set : function (v) { return this.set_priority (v); }}});

// Statics




// Export

exports.default = AssetFactory;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/assets/AssetFactory.js
// module id = 46
// module chunks = 0